import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { RaisedButton, Table, TableBody, TableRow, TableRowColumn, CircularProgress, Divider } from "material-ui";
import { } from "../../Global/actions";
import styles from "../../styles/styles";
import { IniciarValidacionesReplicacionSolicitud, InsertReajuste } from "../SolicitudReajuste/actions";

class SolicitudReajusteReplicar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalSolicitudReplicar: true,
      modalValidacion: false,
      modalCabecera: false,
    };
  }

  componentWillMount() {
  }

  ReplicarSolicitud = () => {
    this.setState({ modalSolicitudReplicar: false });
    this.setState({ modalValidacion: true });
    this.props.dispatch(IniciarValidacionesReplicacionSolicitud());
  }

  AplicarReplicarSolicitud = () => {
    this.setState({ modalValidacion: false });
    this.setState({ modalCabecera: true });
    this.props.dispatch(InsertReajuste({ esReplicacion: true }));
  }

  BColorSegunValidacion = (validacion) => {
    if (validacion === true) {
      return "#dcf7dc";
    }
    if (validacion === false) {
      return "#f7dcdd";
    }
    return "";
  }

  IconSegunValidacion = (validacion) => {
    if (validacion === true) {
      return <i className="material-icons">done</i>;
    }
    if (validacion === false) {
      return <i className="material-icons">clear</i>;
    }
    return <CircularProgress size={25} />;
  }

  render() {
    const centrosAtencionNoEncontrados = [];
    this.props.detalleValidacionCentrosAtencion
      .filter((c) => c.valido === false)
      .forEach((c) => {
        const cc = this.props.centrosAtencion.filter((ca) => ca.Secuencia === c.secuencia);
        if (cc && cc.length > 0) {
          centrosAtencionNoEncontrados.push(cc[0].Descripcion);
        }
      });

    const lvsc = this.props.loadingValidacionSolicitudEnCurso;
    const lvca = this.props.loadingValidacionCentrosAtencion;

    return (
      <div>
        <div className="row">

          {this.state.modalSolicitudReplicar ?
            <div className="col-12" style={{ padding: " 16px 0px" }}>
              ¿Desea replicar la solicitud en isapre&nbsp;
              <strong>{this.props.isapre === "B" ? "VidaTres" : "Banmedica"}</strong>&#63;
              <RaisedButton
                label="Replicar Solicitud"
                onClick={this.ReplicarSolicitud}
                secondary
                labelStyle={{ fontSize: "11px" }}
                overlayStyle={{ borderRadius: 5 }}
                rippleStyle={{ borderRadius: 5 }}
                style={{ width: "190px", borderRadius: 5, marginLeft: 20 }}
                buttonStyle={{ borderRadius: 5 }}
                disabled={!this.props.usuarioPuedeReplicar}
              />
              {!this.props.usuarioPuedeReplicar ?
                <p style={{ color: "#a80000" }}>
                  Permisos insuficientes para replicar solicitud. Contacte a su administrador.
                </p>
                : null}
            </div>
            : null}


          {this.state.modalValidacion ?
            <div style={{ marginTop: 10 }}>
              <Table
                selectable={false}
                multiSelectable={false}
                style={{ width: 800, margin: "auto" }}
              >
                <TableBody displayRowCheckbox={false}>

                  <TableRow style={{ backgroundColor: this.BColorSegunValidacion(lvca) }}>
                    <TableRowColumn>Validación Centros Atención replicados</TableRowColumn>
                    <TableRowColumn style={{ width: 50, padding: 0 }}>
                      {this.IconSegunValidacion(lvca)}
                    </TableRowColumn>
                    <TableRowColumn style={{ whiteSpace: "normal" }}>
                      {lvca === false ?
                        <span>
                          No se encontraron los centros de atención a replicar en :&nbsp;
                          <strong>{centrosAtencionNoEncontrados.join(", ")}</strong><br></br>
                          Favor comunicarse con Convenios Médicos.
                        </span>
                        : null}
                    </TableRowColumn>
                  </TableRow>

                  {centrosAtencionNoEncontrados.length === 0 ?
                    <TableRow style={{ backgroundColor: this.BColorSegunValidacion(lvsc) }}>
                      <TableRowColumn>Validación solicitud en curso</TableRowColumn>
                      <TableRowColumn style={{ width: 50, padding: 0 }}>
                        {this.IconSegunValidacion(lvsc)}
                      </TableRowColumn>
                      <TableRowColumn style={{ whiteSpace: "normal" }}>
                        {lvsc === false ?
                          <span>
                            Ya posee una solicitud, con al menos una prestacion en curso, en la isapre a replicar.
                          </span>
                          : null}
                        {lvsc === true ?
                          <span>No posee solicitudes en curso en la isapre a replicar.</span>
                          : null}
                      </TableRowColumn>
                    </TableRow>
                    : null}
                </TableBody>
              </Table>
              <div className="row justify-content-end" style={{ paddingTop: 10 }}>
                <div className="col-3">
                  <RaisedButton
                    label="Aplicar replicación"
                    onClick={this.AplicarReplicarSolicitud}
                    secondary
                    labelStyle={{ fontSize: "11px" }}
                    overlayStyle={{ borderRadius: 5 }}
                    rippleStyle={{ borderRadius: 5 }}
                    style={{ width: "190px", borderRadius: 5, marginLeft: 20 }}
                    buttonStyle={{ borderRadius: 5 }}
                    disabled={!(lvsc === true && lvca === true)}
                  />
                </div>
              </div>
            </div>
            : null}

        </div>

        {this.state.modalCabecera ?
          <div>
            <div className="row">
              <div className="col-12" style={{ padding: 0, margin: 0 }}>
                <Divider style={{ marginTop: 10, marginBottom: 10 }} />
              </div>
            </div>
            <div className="row" style={{ paddingBottom: 0 }}>
              <div className="col-12" style={{ margin: 0, padding: 0 }}>
                <div style={styles.h2}>
                  Se ha enviado exitosamente su solicitud de reajuste de arancel en isapre
                  <strong> {this.props.isapre === "B" ? "Vida Tres" : "Banmédica"}</strong>
                </div>
              </div>
            </div>
            <div className="row" style={{ paddingBottom: 0, marginTop: 15, marginBottom: 10 }}>
              <div className="col-3" style={styles.colSelectFieldActualizar}>
                <div style={styles.tituloReajustarPrestacionIpc}>
                  N° Solicitud
                </div>
                <div style={styles.datoReajustarPrestacionIpc}>
                  {this.props.cabeceraSolicitud.IdSolicitudReplicada}
                </div>
              </div>
              <div className="col-3" style={styles.colSelectFieldActualizar}>
                <div style={styles.tituloReajustarPrestacionIpc}>
                  Fecha Solicitud
                </div>
                <div style={styles.datoReajustarPrestacionIpc}>
                  {(new Date()).toLocaleDateString()}
                </div>
              </div>
              <div className="col-6" style={styles.colSelectFieldActualizar}>
                <div style={styles.tituloReajustarPrestacionIpc}>
                  Tipo de Solicitud
                </div>
                <div style={styles.datoReajustarPrestacionIpc}>
                  Reajuste IPC
                </div>
              </div>
            </div>
            <div className="row" style={{ paddingBottom: 0, marginTop: 15, marginBottom: 10 }}>
              <div className="col-3" style={styles.colSelectFieldActualizar}>
                <div style={styles.tituloReajustarPrestacionIpc}>
                  Institución
                </div>
                <div style={styles.datoReajustarPrestacionIpc}>
                  {this.props.rutInstitucion}
                </div>
              </div>
              <div className="col-3" style={styles.colSelectFieldActualizar}>
                <div style={styles.tituloReajustarPrestacionIpc}>
                  Fecha Inicio Vigencia Reajuste
                </div>
                <div style={styles.datoReajustarPrestacionIpc}>
                  {this.props.periodoReajuste.FechaVigencia.toLocaleDateString()}
                </div>
              </div>
              <div className="col-6" style={styles.colSelectFieldActualizar}>
                <div style={styles.tituloReajustarPrestacionIpc}>
                  Reajuste
                </div>
                <div style={styles.datoReajustarPrestacionIpc}>
                  {this.props.valorReajuste} %
                </div>
              </div>
            </div>
          </div>
          : null}
      </div>
    );
  }
}

SolicitudReajusteReplicar.defaultProps = {
  loadingValidacionSolicitudEnCurso: null,
  loadingValidacionCentrosAtencion: null,
};

SolicitudReajusteReplicar.propTypes = {
  rutInstitucion: PropTypes.number.isRequired,
  isapre: PropTypes.string.isRequired,
  valorReajuste: PropTypes.number.isRequired,
  centrosAtencion: PropTypes.array.isRequired,
  periodoReajuste: PropTypes.any.isRequired,
  cabeceraSolicitud: PropTypes.any.isRequired,
  detalleValidacionCentrosAtencion: PropTypes.array.isRequired,
  usuarioPuedeReplicar: PropTypes.bool.isRequired,
  loadingValidacionSolicitudEnCurso: PropTypes.bool,
  loadingValidacionCentrosAtencion: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  rutInstitucion: state.global.rutInstitucion,
  isapre: state.global.isapre,
  valorReajuste: state.solicitudReajuste.valorReajuste,

  centrosAtencion: state.global.filtros_CAT.centrosAtencion,
  periodoReajuste: state.filtroBusquedaRA.periodoReajuste,
  cabeceraSolicitud: state.solicitudReajuste.cabeceraSolicitud,
  detalleValidacionCentrosAtencion: state.solicitudReajuste.detalleValidacionCentrosAtencion,
  usuarioPuedeReplicar: state.solicitudReajuste.usuarioPuedeReplicar,
  loadingValidacionSolicitudEnCurso: state.solicitudReajuste.loadingValidacionSolicitudEnCurso,
  loadingValidacionCentrosAtencion: state.solicitudReajuste.loadingValidacionCentrosAtencion,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(SolicitudReajusteReplicar);

